import moment from 'moment'

export const excludeEditData = [
  'id',
  'created_at',
  'updated_at',
  'deleted_at',
  'current_admission_no',
  'financial_start_date',
  'financial_end_date',
  'user_id',
  'contact_id',
  'logo',
  'plan',
  'contact',
  'school_code',
  'user',
]

export function makeContactData (contact) {
  return {
    'contact[address]': contact.address,
    'contact[city]': contact.city,
    'contact[district]': contact.district,
    'contact[landmark]': contact.landmark,
    'contact[pincode]': contact.pincode,
    'contact[state]': contact.state,
    'contact[country]': contact.country,
    'contact[is_primary]': contact.is_primary,
    'contact[country_code]': contact.country_code,
    'contact[phone]': contact.phone,
    'contact[alt_country_code]': contact.alt_country_code,
    'contact[alt_phone]': contact.alt_phone,
    'contact[email]': contact.email,
  }
}

export function makePlanData (plan) {
  return {
    'plan_school[plan_id]': plan.pivot.plan_id,
    'plan_school[price]': plan.pivot.price,
    'plan_school[payment_frequency]': plan.pivot.payment_frequency,
    'plan_school[start_date]': moment(plan.pivot.start_date),
    'plan_school[end_date]': moment(plan.pivot.end_date),
  }
}

export function makeUserData (user) {
  return {
    'user[first_name]': user.first_name,
    'user[last_name]': user.last_name,
    'user[country_code]': user.country_code,
    'user[phone]': user.phone,
    'user[email]': user.email,
  }
}

export function makeWorkingHourData (mwh, wwh) {
  console.log('makeWorkingHourData', { mainworking: mwh, weeklyworking: wwh })
  // console.log('check time', moment(mwh[1].start_time, 'HH:mm:ss'))
  // console.log('daily_working_hour[0][day]', mwh[0].start_time)
  // console.log('daily_working_hour[1[day]', mwh[1].start_time)
  // console.log('daily_working_hour[2][day]', mwh[2].start_time)
  // console.log('daily_working_hour[3][day]', mwh[3].start_time)
  // console.log('daily_working_hour[4][day]', mwh[4].start_time)
  // console.log('daily_working_hour[5][day]', mwh[5].start_time)
  // console.log('daily_working_hour[6][day]', mwh[6].start_time)
  let data = {}
  data = {
    'daily_working_hour[0][day]': mwh.length === 0 ? false : mwh[0].start_time != null,
    'daily_working_hour[0][start_time]': mwh.length === 0 ? null : mwh[0].start_time != null ? moment(mwh[0].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[0][end_time]': mwh.length === 0 ? null : mwh[0].end_time != null ? moment(mwh[0].end_time, 'HH:mm:ss') : null,
    'daily_working_hour[1][day]': mwh.length === 0 ? false : mwh[1].start_time != null,
    'daily_working_hour[1][start_time]': mwh.length === 0 ? null : mwh[1].start_time != null ? moment(mwh[1].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[1][end_time]': mwh.length === 0 ? null : mwh[1].end_time != null ? moment(mwh[1].end_time, 'HH:mm:ss') : null,
    'daily_working_hour[2][day]': mwh.length === 0 ? false : mwh[2].start_time != null,
    'daily_working_hour[2][start_time]': mwh.length === 0 ? null : mwh[2].start_time != null ? moment(mwh[2].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[2][end_time]': mwh.length === 0 ? null : mwh[2].end_time != null ? moment(mwh[2].end_time, 'HH:mm:ss') : null,
    'daily_working_hour[3][day]': mwh.length === 0 ? false : mwh[3].start_time != null,
    'daily_working_hour[3][start_time]': mwh.length === 0 ? null : mwh[3].start_time != null ? moment(mwh[3].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[3][end_time]': mwh.length === 0 ? null : mwh[3].end_time != null ? moment(mwh[3].end_time, 'HH:mm:ss') : null,
    'daily_working_hour[4][day]': mwh.length === 0 ? false : mwh[4].start_time != null,
    'daily_working_hour[4][start_time]': mwh.length === 0 ? null : mwh[4].start_time != null ? moment(mwh[4].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[4][end_time]': mwh.length === 0 ? null : mwh[4].end_time != null ? moment(mwh[4].end_time, 'HH:mm:ss') : null,
    'daily_working_hour[5][day]': mwh.length === 0 ? false : mwh[5].start_time != null,
    'daily_working_hour[5][start_time]': mwh.length === 0 ? null : mwh[5].start_time != null ? moment(mwh[5].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[5][end_time]': mwh.length === 0 ? null : mwh[5].end_time != null ? moment(mwh[5].end_time, 'HH:mm:ss') : null,
    'daily_working_hour[6][day]': mwh.length === 0 ? false : mwh[6].start_time != null,
    'daily_working_hour[6][start_time]': mwh.length === 0 ? null : mwh[6].start_time != null ? moment(mwh[6].start_time, 'HH:mm:ss') : null,
    'daily_working_hour[6][end_time]': mwh.length === 0 ? null : mwh[6].end_time != null ? moment(mwh[6].end_time, 'HH:mm:ss') : null,
    'weekly_working_hour[same_daily_timing]': wwh === null ? false : wwh.same_daily_timing === 1,
  }
  console.log('after data', data)

  return data
}
